import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PreferenceLogo from './preferenceLogo';

const mapStateToProps = state => ({
  appLogo: state.app.appPreference.appLogo,
});

export default withRouter(connect(mapStateToProps)(PreferenceLogo));
